import React from "react";
import { ShieldCheck, Flame, Award, Video, ShoppingBag, Sparkles } from "lucide-react";
import SuccessStoriesSection from "@/components/SuccessStoriesSection";
import { TRUST_BADGES } from "@/data/homepageData";

const STATS = [
  ["∞", "AI-Generated 30-Day Challenges", Flame, "#FB7185"],
  ["∞", "Certification Tracks", Award, "#5C9DFF"],
  ["1", "Live Meeting Platform", Video, "#22D3EE"],
  ["∞", "Growing Course Marketplace", ShoppingBag, "#34D399"],
  ["100%", "Free to Start", Sparkles, "#B58BFF"],
];

/** Section 5 — Social Proof: stats, trust badges, hiring-partner line, testimonials. */
export const SocialProofSection = () => {
  return (
    <section className="py-8" data-testid="social-proof-section">
      <div className="border-y border-white/10 bg-white/[0.02]">
        <div className="max-w-6xl mx-auto px-6 py-10 grid grid-cols-2 sm:grid-cols-5 gap-4 sm:gap-6">
          {STATS.map(([num, label, Icon, color], i) => (
            <div
              key={label} data-testid={`social-proof-stat-${i}`}
              className="flex flex-col items-center text-center gap-2.5 px-2 py-4 rounded-2xl border border-white/5 hover:border-white/10 transition-colors duration-300"
            >
              <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: `${color}18`, border: `1px solid ${color}30` }}>
                <Icon className="w-4 h-4" style={{ color }} strokeWidth={1.75} />
              </div>
              <div className="font-heading text-2xl sm:text-3xl font-bold text-white">{num}</div>
              <div className="text-[11px] text-slate-400 uppercase tracking-wider leading-tight">{label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-10 flex flex-wrap items-center justify-center gap-3" data-testid="trust-badges-row">
        {TRUST_BADGES.map((b) => (
          <span key={b} className="flex items-center gap-1.5 text-xs font-semibold text-slate-300 bg-white/[0.03] border border-white/10 rounded-full px-3.5 py-2">
            <ShieldCheck className="w-3.5 h-3.5 text-emerald-400" /> {b}
          </span>
        ))}
      </div>

      <SuccessStoriesSection />
    </section>
  );
};
